/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from "react";
import { useContext } from "../../../context";

export function Delete() {
  const { modals } = useContext();

  return (
    <a
      className="new-red-btn pull-right"
      data-mode="delete"
      onClick={modals.delete.open}
    >
      Delete
    </a>
  );
}
